// extracted by mini-css-extract-plugin
export var base = "_1n-0";
export var updateBanner = "_1n-1";